import { createSelector } from 'reselect';
import { getInsurances, getSelectedInsuranceID } from './getInsurances';

export const getSelectedInsurance = createSelector(
  [getInsurances, getSelectedInsuranceID],
  (insurances, insuranceID) => {
    return insurances.find(({ id }) => id === insuranceID);
  },
);
